<template>
  <res-dialog 
    :showDialog="showDialog"
    :maxWidth="maxWidth"
    :setWidth="setWidth"
    :title="'Publish Budget?'"
    :titleClass="'resBlue darken-1 white--text'"
    :showTitleIcon="true"
    :titleIconSize="17"
    :iconColor="'white'"
    :saveButtonText="'YES, PUBLISH'"
    :saveDisabled="false"
    :cancelButtonText="'CANCEL'"
    :cancelButtonWidth="'80'"
    :defaultButtonAction="confirmPublish"
    @save="confirmPublish"
    @cancel="confirmCancel" >
    <v-card-text>
      <span class="font-weight-500">
         {{message}}
      </span>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    components: {
      ResDialog
    },
    props: {
      showDialog: {
        type: Boolean
      },
      maxWidth: {
        type: Number
      },
      setWidth: {
        type: Number
      },
    },
    methods: {
      confirmCancel() {
        this.$emit('cancel-publish', true)
      },
      confirmPublish() {
        this.$emit('confirm-publish', true)
      }
    },
    computed: {
      message() {
        return `Are you sure you want to publish this budget? Publishing will inform ResMan app to use these budget values for reporting, invoices, etc... during the corresponding accounting periods.`;
      } 
    }
  }
</script>

